export default "__VITE_ASSET__BGBIF$au__"